import scrollToPosition from '../scroll';
import { throttle } from '@scripts/misc/utils';

window.addEventListener('load', function () {
  if (document.getElementsByClassName('js-anchored-nav-container').length > 0) {
    let sections = [];

    // Get all sections we can scroll to
    document.querySelectorAll('.js-anchored-nav-item').forEach((item) => {
      let headingDataTag = item.getAttribute('data-tag');
      let headingDataText = item.getAttribute('data-text');
      let searchCallback = (element) => element.textContent === headingDataText;

      let searchTags = Array.from(document.getElementsByTagName(headingDataTag));
      let searchResults = searchTags.filter(searchCallback);

      if (searchResults.length > 0) {
        searchResults[0].setAttribute('data-text', headingDataText);
        searchResults[0].classList.add('js-anchored-nav-section-title');
        sections.push(searchResults[0]);
      }
    });

    if (sections.length > 0) {
      // Highlight anchor link when on current section
      document.addEventListener(
        'scroll',
        throttle(() => {
          var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

          sections.forEach((item) => {
            if (item.getBoundingClientRect().top + window.scrollY - 130 <= scrollPosition) {
              document.querySelector('.js-anchored-nav-item.is-active')?.classList.remove('is-active');
              document
                .querySelector(`[data-text="${item.textContent}"].js-anchored-nav-item`)
                ?.classList.add('is-active');
            }
          });
        }),
      );

      document.querySelectorAll('.js-anchored-nav-item').forEach((item) => {
        item.addEventListener('click', (event) => {
          sections.forEach((item) => {
            // Get section related to nav item
            const scrollToSection = document.querySelector(
              `[data-text="${item.textContent}"].js-anchored-nav-section-title`,
            );

            if (
              scrollToSection &&
              scrollToSection.getAttribute('data-text') === event.target.getAttribute('data-text')
            ) {
              let targetHeadingPosition = scrollToSection.getBoundingClientRect().top + window.scrollY;

              scrollToPosition(targetHeadingPosition);
            }
          });
        });
      });
    }
  }
});
